// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Ngk7","productName":"Table_productName__3VAZu"};